import {
  HamburgerIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons';
import {
  useDisclosure,
  Button,
  Drawer,
  Text,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Stack,
  Box,
  HStack,
  Icon,
  Spacer,
  Avatar,
  Badge,
  IconButton,
  Tooltip,
  VStack,
  useColorModeValue,
  Collapse,
} from '@chakra-ui/react';
import {
  FiHome,
  FiMail,
  FiClipboard,
  FiSettings,
  FiUsers,
  FiUserPlus,
  FiLogOut,
  FiShoppingCart,
  FiServer,
  FiUserCheck,
  FiFileText,
  FiDatabase,
  FiCalendar,
  FiShoppingBag,
  FiBarChart2,
} from 'react-icons/fi';
import { BsChat, BsGlobe } from 'react-icons/bs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ElementType } from 'react';
import {
  getCurentOrgDataFromStorage,
  getOrganizations,
  storeOrgDataToStorage,
} from '../../services/organization';
import { logOut } from '../../services/account';
import { motion } from 'framer-motion';
import OrganizationDropdown from './OrganizationDropDown';
import { Organization, User, WhatsappNumber } from '../../utils/types';
import { getUserProfile } from '../../hooks/users';
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
} from 'react-icons/fa';
import { getEmailAccount } from '../../hooks/email';
import { getFacebookProfile } from '../../hooks/facebook';
import { getInstagramUserProfile } from '../../hooks/instagram';
import { getWANumber } from '../../hooks/whatsapp';

export default function SideDrawerBar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [orgState, setOrgState] = useState<Organization[]>([]);
  const [orgId, setOrgId] = useState<string>();
  const [user, setUser] = useState<User>();
  const [inboxOpen, setInboxOpen] = useState(false);
  const [salesOpen, setSalesOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  const [whatsappNumber, setWhatsappNumber] = useState<WhatsappNumber[]>([]);
  const [instagramAccId, setInstagramAccId] = useState<any>();
  const [facebookAccId, setFacebookAccId] = useState<any>();
  const [emailAcc, setEmailAcc] = useState<any>();

  const navigate = useNavigate();

  const onMenuItemClick = (path: string) => {
    setTimeout(() => navigate(path), 120);
  };

  const bg = useColorModeValue('white', 'gray.800');
  const hoverBg = useColorModeValue('gray.50', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.200');

  const loadInit = async () => {
    const waResult = await getWANumber(orgId);
    if (waResult.success) {
      console.log('retrieved whatsapp data', waResult.data);
      setWhatsappNumber(waResult.data);
    }

    const instaResult = await getInstagramUserProfile(orgId);
    if (instaResult.success) {
      setInstagramAccId(
        Array.isArray(instaResult.data) && instaResult.data.length > 0
          ? instaResult.data[0]
          : null,
      );
      console.log('instagram acc', instaResult);
    }

    const fbResult = await getFacebookProfile(orgId);
    if (fbResult.success && fbResult.data.length > 0)
      setFacebookAccId(fbResult.data);
  };

  useEffect(() => {
    if (orgId) {
      loadInit();
    }
  }, [orgId]);

  const itemVariants = {
    hidden: { opacity: 0, x: -8 },
    visible: { opacity: 1, x: 0 },
  };

  const menuItems = [
    {
      icon: FiHome,
      title: 'Home',
      path: `/organization/${orgId}/`,
    },
    {
      isGroup: true,
      title: 'Sales',
      icon: FiBarChart2,
      isOpen: salesOpen,
      toggle: () => setSalesOpen(!salesOpen),
      items: [
        {
          icon: FiUsers,
          title: 'Leads',
          path: `/organization/${orgId}/leads-dashboard`,
        },
        // {
        //   icon: FiUserCheck,
        //   title: 'Customers',
        //   path: `/organization/${orgId}/customers-dashboard`,
        // },
        {
          icon: FiServer,
          title: 'Contact Companies',
          path: `/organization/${orgId}/manage-companies`,
        },
        {
          icon: FiFileText,
          title: 'Quotations',
          path: `/organization/${orgId}/quotes`,
        },

        {
          icon: FiShoppingBag,
          title: 'My Orders',
          path: `/organization/${orgId}/orders`,
        },
      ],
    },
    {
      isGroup: true,
      title: 'Inbox',
      icon: FiMail,
      isOpen: inboxOpen,
      toggle: () => setInboxOpen(!inboxOpen),
      items: [
        {
          icon: FaWhatsapp,
          title: 'Whatsapp',
          path:
            whatsappNumber && whatsappNumber.length > 0
              ? `/organization/${orgId}/inbox/whatsapp/conversations`
              : `/organization/whatsapp`,
        },
        {
          icon: FaFacebook,
          title: 'Facebook',
          path: facebookAccId
            ? `/organization/${orgId}/inbox/facebook/conversations`
            : `/organization/inbox/facebook-messenger`,
        },
        {
          icon: FaInstagram,
          title: 'Instagram',
          path:
            instagramAccId?.id
              ? `/organization/${orgId}/inbox/instagram/conversations`
              : `/organization/inbox/instagram`,
        },
        {
          icon: FaEnvelope,
          title: 'Email',
          path: emailAcc
            ? `/organization/${orgId}/inbox/email/conversations`
            : `/organization/${orgId}/inbox/email`,
        },
      ],
    },
    {
      icon: FiShoppingCart,
      title: 'Catalogue',
      path: `/organization/${orgId}/catalogue`,
    },
    {
      icon: BsGlobe,
      title: 'Manage Website',
      path: `/organization/${orgId}/website`,
    },
    {
      icon: BsChat,
      title: 'Team Chat',
      path: `/organization/${orgId}/teamchat/conversations/`,
    },
    {
      icon: FiCalendar,
      title: 'Calendar',
      path: `/organization/${orgId}/calendar`,
    },
    {
      icon: FiClipboard,
      title: 'Tasks',
      path: `/organization/${orgId}/tasks/`,
    },
    {
      isGroup: true,
      title: 'Settings',
      icon: FiSettings,
      isOpen: settingsOpen,
      toggle: () => setSettingsOpen(!settingsOpen),
      items: [
        {
          icon: FiUserPlus,
          title: 'My Team',
          path: `/organization/${orgId}/team/`,
        },
        {
          icon: FiDatabase,
          title: 'Organization Data for AI',
          path: `/organization/${orgId}/info`,
        },
        {
          icon: FiSettings,
          title: 'Organization Settings',
          path: `/organization/${orgId}/settings/`,
        },
      ],
    },
  ];

  useEffect(() => {
    getOrgsInit();
  }, []);

  const getOrgsInit = async () => {
    let storedOrg = await getCurentOrgDataFromStorage();
    console.log('stored org', storedOrg);
    let response = await getOrganizations();
    console.log('fetched orgs from storage', response);
    let userResponse = await getUserProfile();
    if (response.success === true && response.data) {
      if (
        storedOrg?.success === true &&
        typeof storedOrg.data === 'object' &&
        storedOrg.data !== null
      ) {
        storeOrgDataToStorage(storedOrg?.data);
        setOrgId(storedOrg?.data?.id);
      } else {
        let defaultOrg = response?.data[0];
        storeOrgDataToStorage(defaultOrg);
        setOrgId(defaultOrg?.id);
      }
      if (userResponse.success === true && userResponse.data) {
        setUser(userResponse.data);
        console.log('user data', userResponse.data);
      }
      setOrgState(response.data);
    } else {
      setOrgState([]);
    }
    return response;
  };

  const handleOrgClick = (selectedOrg: Organization) => {
    storeOrgDataToStorage(selectedOrg);
    setOrgId(selectedOrg?.id);
    navigate(`/organization/${selectedOrg?.id}`);
    window.location.reload();
  };

  const handleLogOut = async () => {
    logOut();
    window.location.href = '../../';
  };

  return (
    <>
      <Button colorScheme="gray" onClick={onOpen}>
        <HamburgerIcon />
      </Button>
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent zIndex={15}>
          <DrawerCloseButton />
          <DrawerBody>
            <Stack spacing="12px" mt={50} w="full">
              <OrganizationDropdown
                organizations={orgState}
                onClose={onClose}
                selectedOrgId={orgId || 'undefined'}
                onSelectOrg={handleOrgClick}
              />

              {orgId &&
                menuItems.map((mi) => {
                  if (mi.isGroup) {
                    return (
                      <Box key={mi.title} w="full">
                        <Button
                          variant="ghost"
                          justifyContent="space-between"
                          w="full"
                          leftIcon={
                            <Icon as={mi.icon as ElementType} boxSize={5} />
                          }
                          onClick={mi.toggle}
                          _hover={{ bg: hoverBg }}
                        >
                          <HStack
                            spacing={3}
                            flex="1"
                            justify="space-between"
                            w="full"
                          >
                            <Text fontSize="md" color={textColor}>
                              {mi.title}
                            </Text>
                            <Icon
                              as={
                                mi.isOpen ? ChevronDownIcon : ChevronRightIcon
                              }
                              boxSize={5}
                              transition="all 0.2s"
                            />
                          </HStack>
                        </Button>

                        <Collapse in={mi.isOpen} animateOpacity>
                          <Stack pl={4} spacing={1} mt={1}>
                            {mi.items.map((sub) => (
                              <motion.div
                                key={sub.title}
                                initial="hidden"
                                animate="visible"
                                variants={itemVariants}
                              >
                                <Button
                                  variant="ghost"
                                  justifyContent="start"
                                  w="full"
                                  leftIcon={
                                    <Icon
                                      as={sub.icon as ElementType}
                                      boxSize={5}
                                    />
                                  }
                                  onClick={() => onMenuItemClick(sub.path)}
                                  _hover={{ bg: hoverBg }}
                                >
                                  <Text fontSize="md" color={textColor}>
                                    {sub.title}
                                  </Text>
                                </Button>
                              </motion.div>
                            ))}
                          </Stack>
                        </Collapse>
                      </Box>
                    );
                  }

                  return (
                    <motion.div
                      key={mi.title}
                      initial="hidden"
                      animate="visible"
                      variants={itemVariants}
                      transition={{ duration: 0.18 }}
                    >
                      <Button
                        variant="ghost"
                        justifyContent="start"
                        w="full"
                        leftIcon={
                          <Icon as={mi.icon as ElementType} boxSize={5} />
                        }
                        onClick={() =>
                          onMenuItemClick(
                            mi.path || `/organization/${orgId}/home`,
                          )
                        }
                        _hover={{ bg: hoverBg }}
                      >
                        <HStack spacing={3} w="full" align="center">
                          <Text fontSize="md" color={textColor}>
                            {mi.title}
                          </Text>
                          <Spacer />
                        </HStack>
                      </Button>
                    </motion.div>
                  );
                })}
            </Stack>
          </DrawerBody>

          <Box borderTopWidth="1px" bg="gray.50" p={3}>
            <HStack spacing={3} cursor="pointer">
              <Box position="relative">
                <Avatar
                  name={user?.email || 'User'}
                  size="sm"
                  bg="#006400"
                  color="white"
                />
                <Box
                  position="absolute"
                  bottom="0"
                  right="-2px"
                  width="10px"
                  height="10px"
                  borderRadius="full"
                  bg="green.400"
                  border={`2px solid ${bg}`}
                />
              </Box>
              <VStack
                align="start"
                spacing={0}
                onClick={() => navigate('/user/account/')}
              >
                <Text
                  fontWeight="bold"
                  fontSize="sm"
                  color={textColor}
                  maxW="210px"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  title={user?.email} // shows full email on hover
                >
                  {user?.email ?? 'Loading...'}
                </Text>
                <HStack spacing={2}>
                  <Badge size="sm" colorScheme="green">
                    Active
                  </Badge>
                  <Text fontSize="xs" color="gray.500">
                    Signed in
                  </Text>
                </HStack>
              </VStack>
              <Spacer />
              <Tooltip label="Logout">
                <IconButton
                  aria-label="Logout"
                  icon={<Icon as={FiLogOut as ElementType} />}
                  size="xs"
                  colorScheme="red"
                  variant="ghost"
                  onClick={handleLogOut}
                />
              </Tooltip>
            </HStack>
          </Box>
        </DrawerContent>
      </Drawer>
    </>
  );
}
